module.exports = __webpack_public_path__ + "img/shadow-hand.67e9b7f1.png";